import { k, useCss } from 'kremling'
import React from 'react'

import { TextInput } from '@components/mantine/text-input.component'
import { Switch } from '@components/radix/switch'
import { RichText } from '@components/rich-text/rich-text.component'
import { ChoiceBuilder } from './choice-builder.component'

type FieldCheckboxProps = {
  field: Field
  onChange: (field: Field, debounce?: boolean) => void
  isRequired: boolean
  updateRequiredToggle: (value: boolean, fieldId: string) => void
}

export function FieldCheckbox({
  field,
  onChange,
  updateRequiredToggle,
  isRequired,
}: FieldCheckboxProps) {
  const scope = useCss(css)

  function updateFieldLabel(label: string) {
    if (label === field.label) return
    const updatedField = {
      ...field,
      label,
    }
    onChange(updatedField)
  }

  function updateFieldDescription(description: string) {
    const updatedField = {
      ...field,
      description,
    }
    onChange(updatedField)
  }

  function updateChoices(choices: string[]) {
    const updatedField = {
      ...field,
      choices,
    }
    onChange(updatedField, false)
  }

  return (
    <div
      {...scope}
      className="space-y-6"
    >
      <div>
        <div className="flex items-center">
          <Switch
            id={`required-switch-${field.id}`}
            onChange={value => updateRequiredToggle(value, field.id)}
            className="mr-2"
            value={isRequired}
          />
          <label htmlFor={`required-switch-${field.id}`}>Required</label>
        </div>
      </div>
      <div className="form-group">
        <TextInput
          label="Description title"
          defaultValue={field.label}
          onChange={updateFieldLabel}
          placeholder="e.g. Select your favorite colors"
          autoFocus
        />
      </div>
      <div className="form-group">
        <label htmlFor="text-field-desc">Describe this field</label>
        <RichText
          id="text-field-desc"
          onChange={updateFieldDescription}
          initialValue={field ? field.description : null}
          placeholder="Type here..."
        />
      </div>
      <div className="form-group">
        <ChoiceBuilder
          field={field}
          onChange={updateChoices as any}
          title="Checkbox choices"
        />
      </div>
    </div>
  )
}

const css = k`

`
